import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteChangeLoader = () => {
  const location = useLocation();

  useEffect(() => {
    // 👇 Simulate tab loading spinner
    document.title = 'Loading...';
    document.body.style.cursor = 'progress';

    // Restore after short delay
    const timeout = setTimeout(() => {
      document.title = 'ClinicSync'; // or use a dynamic title system
      document.body.style.cursor = 'default';
    }, 500); // Adjust duration to feel right

    return () => clearTimeout(timeout);
  }, [location]);

  return null; // this component doesn’t render anything
};

export default RouteChangeLoader;
